'use client';

import Card from '@/components/Team';
import { Fragment } from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';

// Animation variants
const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: 'easeOut' },
    },
};

export default function Home() {
    return (
        <Fragment>
            <div
                id="page-1"
                className="
                    relative
                    min-h-[500px] md:min-h-[600px]
                    overflow-hidden
                    w-screen
                    -mx-4 sm:-mx-6 md:mx-0
                "
            >
                {/* FULL BACKGROUND */}
                <div className="absolute top-0 left-0 right-0 bottom-0 z-0">
                    <Image
                        src="/images/teamsphoto3.jpeg"
                        alt="Team Background"
                        fill
                        priority
                        className="object-cover object-center w-full h-full"
                        sizes="100vw"
                        quality={100}
                    />
                    <div className="absolute inset-0 bg-white/60" />
                </div>

                {/* Content */}
                <div className="relative z-10">
                    <div id="content">
                        <div className="w-full flex flex-col md:flex-row items-center min-h-[500px] md:min-h-[600px]">
                            {/* Text Section */}
                            <motion.div
                                className="md:w-1/2 px-8 md:px-28 py-16 md:py-28 text-center md:text-left"
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                            >
                                <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 leading-snug">
                                    Fueled by Passion ⚡️,
                                    <br className="hidden md:block" />
                                    Driven by Results 💯
                                </h1>

                                <motion.p
                                    className="font-semibold my-6 text-gray-800 text-base md:text-lg"
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.2 }}
                                >
                                    From ideation to implementation, Wahni IT
                                    Solutions boasts a diverse team of
                                    specialists, each dedicated to exceeding
                                    expectations.
                                </motion.p>
                            </motion.div>
                            <div className="hidden md:block md:w-1/2"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Team Card Section */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <Card />
            </motion.div>
        </Fragment>
    );
}
